export const formatKeyValue = (
  title: string,
  keyValuePairs: Array<[string, string]>
): string => {
  const rows = keyValuePairs
    .map(([key, value]) => `**${key}:** ${value}`)
    .join('\n\n')

  return `## ${title}\n\n${rows}`
}
